
<template>
  <div class="radio-button">
    <svg v-if="!value" @click.prevent.stop="updateRadioButton" class="radio-button__unselected" width="24" height="24" viewBox="0 0 24 24">
      <path fill="#8F90A6" d="M12 4c-4.416 0-8 3.584-8 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8zm0 14.4c-3.536 0-6.4-2.864-6.4-6.4 0-3.536 2.864-6.4 6.4-6.4 3.536 0 6.4 2.864 6.4 6.4 0 3.536-2.864 6.4-6.4 6.4z"/>
    </svg>
    <svg  v-if="value" @click.prevent.stop="updateRadioButton" class="radio-button__selected" width="14" height="14" viewBox="0 0 14 14">
      <g fill="none" fill-rule="evenodd">
        <path d="M1 1L25 1 25 25 1 25z" transform="translate(-6 -6)"/>
        <path :fill="fillCross" fill-rule="nonzero"
              d="M17.861 19.452L13 14.591l-4.861 4.861c-.39.39-1.024.39-1.415 0l-.176-.176c-.39-.391-.39-1.024 0-1.415L11.409 13 6.548 8.139c-.39-.39-.39-1.024 0-1.415l.176-.176c.391-.39 1.024-.39 1.415 0L13 11.409l4.861-4.861c.39-.39 1.024-.39 1.415 0l.176.176c.39.391.39 1.024 0 1.415L14.591 13l4.861 4.861c.39.39.39 1.024 0 1.415l-.176.176c-.391.39-1.024.39-1.415 0z"
              transform="translate(-6 -6)"/>
      </g>
    </svg>
  </div>
</template>

<script>
/**
 * Stylized radio-button
 */
export default {
  name: 'BaseRadioButton',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    crossColor: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      value: this.modelValue
    }
  },
  watch: {
    modelDalue(value) {
      this.value = value
    }
  },
  computed: {
    fillCross () {
      return this.crossColor || '#fff'
    }
  },
  methods: {
    updateRadioButton () {
      this.value = !this.value
      this.$emit('change', this.value)
    }
  }
}
</script>

<style scoped lang="scss">
  .radio-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 26px;
    width: 26px;

    &__unselected {
    }

    &__selected {
    }
  }
</style>
